exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5eee6b51]:root{touch-action:pan-x pan-y;height:100%}.container-fluid[data-v-5eee6b51]{min-height:80vh;height:80vh;overflow-y:scroll}@media screen and (min-width:1200px){.container-fluid[data-v-5eee6b51]{min-height:65vh;height:65vh;overflow-y:scroll}}", ""]);

// exports
